module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-b-sm"
  }, [_c('div', {
    staticClass: "row table-filter"
  }, [_c('div', {
    staticClass: " col-xs-12"
  }, [_c('h4', {
    staticClass: "table-name"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "b-b"
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "display": "none"
    },
    style: (_vm.view_mounted)
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-xs"
  }, [_vm._v("\n                                岗位名称:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10  n-p-l p-t-xs label-text"
  }, [_vm._v("\n                                " + _vm._s(_vm.post.name) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-xs"
  }, [_vm._v("\n                                岗位别名:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10  n-p-l p-t-xs label-text"
  }, [_vm._v("\n                                " + _vm._s(_vm.post.alias) + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-xs "
  }, [_vm._v("\n                                答题时间:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 n-p-l p-t-xs label-text"
  }, [_vm._v("\n                                " + _vm._s(_vm.post.duration === -1 ? '不限时' : _vm.post.duration + '（s）') + "\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-xs "
  }, [_vm._v("\n                                岗位类型:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 n-p-l p-t-xs label-text"
  }, [_vm._v("\n                                " + _vm._s(_vm.post.post_category === 1 ? '系统内置' : '公司') + "\n                            ")])])]), _vm._v(" "), (_vm.post.post_category === 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-xs "
  }, [_vm._v("\n                                发布人:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 n-p-l p-t-xs label-text"
  }, [_vm._v("\n                                " + _vm._s((_vm.post.post_owner ? _vm.post.post_owner.realname : '管理员')) + "\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.post.post_category === 2) ? _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-xs "
  }, [_vm._v("\n                                测评次数:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-5 n-p-l p-t-xs label-text"
  }, [_vm._v("\n                                " + _vm._s(_vm.post.evaluate_num) + "\n                            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-b-sm"
  }, [_vm._v("\n                                关联能力群:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-8 n-p-l p-t-xs"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-sm list-group"
  }, _vm._l((_vm.post.abilities), function(ability, ind) {
    return _c('div', {
      key: ability.ability._id,
      staticClass: "list-group-item row"
    }, [_c('div', {
      staticClass: "btn col-xs-12 n-b-r btn-md",
      class: {
        'btn-success': ind % 3 === 0, 'btn-warning': ind % 3 === 1, 'btn-danger': ind % 3 === 2
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_vm._v(_vm._s(ability.ability.name))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6"
    }, [_c('span', [_vm._v("权重:")]), _vm._v(" "), _c('span', {
      staticClass: "bold"
    }, [_vm._v(_vm._s(ability.weight))])])])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12 m-t-sm list-group-sub"
    }, _vm._l((ability.indicators), function(indicator, ind) {
      return _c('div', {
        key: indicator.indicator._id,
        staticClass: "list-group-sub-item"
      }, [_c('div', {
        staticClass: "btn col-xs-12 n-f",
        class: {
          'btn-success': ind % 3 === 2, 'btn-warning': ind % 3 === 1, 'btn-danger': ind % 3 === 0
        }
      }, [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-xs-6"
      }, [_vm._v(_vm._s(indicator.indicator.name))]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-6"
      }, [_c('span', [_vm._v("权重:")]), _vm._v(" "), _c('span', {
        staticClass: "bold"
      }, [_vm._v(_vm._s(indicator.weight))])])])])])
    }))])
  })), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: " b-b b-dashed"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2 text-right label p-t-xs"
  }, [_vm._v("\n                                岗位说明:\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-10 n-p-l p-t-xs label-text"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.post.desc)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary btn-sm",
    on: {
      "click": function($event) {
        _vm.back()
      }
    }
  }, [_vm._v("返回")])])])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68822848","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/company/post/show.vue
// module id = 489
// module chunks = 1